module.exports = __webpack_public_path__ + "static/feature-00e8c699d331b08b0a3dbccba9b378ed.png";